/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Advantages_ReferencesInputs */

const en_homepage_advantages_references = /** @type {(inputs: Homepage_Advantages_ReferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`References`)
};

const es_homepage_advantages_references = /** @type {(inputs: Homepage_Advantages_ReferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referencias`)
};

/**
* | output |
* | --- |
* | "References" |
*
* @param {Homepage_Advantages_ReferencesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_advantages_references = /** @type {((inputs?: Homepage_Advantages_ReferencesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Advantages_ReferencesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_advantages_references(inputs)
	return en_homepage_advantages_references(inputs)
});